import { render, staticRenderFns } from "./Departments.vue?vue&type=template&id=2384ce08&scoped=true"
import script from "./Departments.vue?vue&type=script&lang=js"
export * from "./Departments.vue?vue&type=script&lang=js"
import style0 from "./Departments.vue?vue&type=style&index=0&id=2384ce08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384ce08",
  null
  
)

export default component.exports